import classNames from 'classnames';
import Icon, { IconProps } from '../../Atoms/Icon';

interface RatingProps {
  rating: number;
  maxRating?: number;
  className?: string;
}

const calculatePercentage = (
  value: number,
  total: number
): number => (total === 0 ? 0 : (value / total) * 100);

function RatingStars({
  rating,
  maxRating = 5,
  className
}: RatingProps) {
  const getStars = (icon: string) =>
    Array.from({ length: maxRating }, (star, index) => (
      <Icon key={index} icon={icon as IconProps} />
    ));

  return (
    <div className={classNames(['relative', className])}>
      <div className="flex flex-nowrap text-3xl text-sl-yellow">
        {getStars('star-regular')}
      </div>
      <div
        className="absolute top-0 left-0 z-10 flex flex-nowrap overflow-hidden text-3xl text-sl-yellow"
        style={{
          maxWidth: `${calculatePercentage(
            rating,
            maxRating
          )}%`
        }}
      >
        {getStars('star')}
      </div>
    </div>
  );
}

export default RatingStars;
